import { IonTemplate } from '../classes/templates/IonTemplate.js';
export const ion = (key, get, config) => new IonTemplate(key, get, config);
